import React from 'react';
import QuestionEntity, { QuestionEntityData } from './QuestionEntity';
import {
  RadioButtonsGrid,
  RadioButtonsGridData,
} from '../answers/RadioButtonsGrid';
import {
  RadioButtonsGridRow,
  RadioButtonsGridRowData,
} from '../answers/RadioButtonGridRow';
import QuestionType from '@ax2/common/model/QuestionType';
export type RadioButtonGridQuestionData = Omit<
  QuestionEntityData,
  'answerElement'
> &
  RadioButtonsGridData &
  RadioButtonsGridRowData;

export const RadioButtonGridQuestion: React.FC<
  RadioButtonGridQuestionData
> = props => {
  return (
    <QuestionEntity
      {...props}
      answerElement={
        props.questionType &&
        props.questionType === QuestionType.RadioButtonGrid ? (
          <RadioButtonsGrid {...props} />
        ) : (
          <RadioButtonsGridRow {...props} />
        )
      }
    />
  );
};
